import { CustomSurfaceTreatmentsDto } from "#modules/companySettings/infra/fetchCustomSurfaceTreatments.api";
import { DEFAULT_CSV_DELIMITER } from "#shared/constants";

type Treatment = CustomSurfaceTreatmentsDto[number];

type ExportableFields = Omit<Treatment, "id" | "createdAt" | "updatedAt" | "companySettingsId">;

const fieldSerializers: { [K in keyof Required<ExportableFields>]: (t: Treatment) => string } = {
  description: (t) => t.description,
  method: (t) => t.method,
  price: (t) => t.price?.toString() ?? "",
  formula: (t) => t.formula ?? "",
  preparationTimeFormula: (t) => t.preparationTimeFormula ?? "",
  cycleTimeFormula: (t) => t.cycleTimeFormula ?? "",
  type: (t) => t.type,
  industrialProcess: (t) => t.industrialProcess ?? "",
};

const HEADERS = Object.keys(fieldSerializers) as (keyof ExportableFields)[];

export const makeCustomSurfaceTreatmentsCsv = (surfaceTreatments: CustomSurfaceTreatmentsDto) => {
  const csvData = [HEADERS.join(DEFAULT_CSV_DELIMITER)];

  if (surfaceTreatments.length === 0) {
    return csvData;
  }

  const rows = surfaceTreatments.map((treatment) =>
    HEADERS.map((key) => fieldSerializers[key](treatment)).join(DEFAULT_CSV_DELIMITER),
  );

  return csvData.concat(rows);
};
